import React from "react";
import { useContent } from "@/context/ContentContext";
import SocialLinks from "@/components/SocialLinks";
import BioText from "@/components/BioText";
import { Reveal } from "@/components/Reveal";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Bio() {
  const { content } = useContent();
  usePageMeta(
    "Bio — Okaytwitchy | CHILLWOAH",
    "The story of Okaytwitchy — independent Brooklyn recording artist, founder of the CHILLWOAH world and the XRABI fashion line."
  );

  return (
    <div data-testid="bio-page">
      <header className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 sm:pt-24 pb-10">
        <p className="font-mono text-xs sm:text-sm font-semibold tracking-[0.3em] uppercase text-[#F26522]">The Artist</p>
        <h1 className="mt-4 font-display font-extrabold uppercase text-4xl sm:text-6xl lg:text-7xl text-white tracking-tight leading-[0.95]">
          Okaytwitchy
        </h1>
        <div className="rule-lux mt-8" aria-hidden="true" />
      </header>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16 sm:pb-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <Reveal className="lg:col-span-5">
            <div className="relative border border-[#1A1A22] bg-[#0F0F14] lg:sticky lg:top-32">
              <img
                src={content?.images?.bio}
                alt="Okaytwitchy as a child with his mother — vintage CHILLWOAH photograph"
                loading="lazy"
                className="w-full h-auto"
              />
              <span className="absolute bottom-4 left-4 font-mono text-xs tracking-[0.25em] uppercase text-[#F5E6D3] bg-[#08080A]/85 backdrop-blur px-3 py-1.5 border border-[#2A2A36]">
                {content?.social_handle || "@okaytwitchy"} — Brooklyn, NY
              </span>
            </div>
          </Reveal>

          <div className="lg:col-span-7 flex flex-col gap-12">
            <Reveal delay={0.1}>
              <BioText />
            </Reveal>
            <Reveal>
              <div className="border border-[#1A1A22] bg-[#0F0F14] p-6 sm:p-8">
                <p className="font-mono text-xs font-semibold tracking-[0.3em] uppercase text-[#F26522] mb-4">
                  Follow the world
                </p>
                <SocialLinks content={content} />
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
